export default "__VITE_ASSET__C2Y9Q_H$__"